import type { SortDirection } from '#layers/base/public';
import type { QuerySort } from '#layers/collection-query/public';
import type { GlobalPrimitiveFieldId } from '#layers/data-model/public';
import type { LayoutSortingState } from '#layers/listing/types/layout';
import { useWorkspaceSchemaStore } from '#layers/data-model/public';

/**
 * Converts a layout's sorting to the query's. Sorts the read does not accept, such as a saved view's
 * sort on a field that lost its sort capability, are dropped rather than sent.
 */
export function useConvertLayoutSortingStateToQuerySort(directions: (fieldId: GlobalPrimitiveFieldId) => SortDirection[]) {
	const { findPrimitiveFieldById } = useWorkspaceSchemaStore();

	function convert(layoutSortingState: LayoutSortingState | undefined): QuerySort | undefined {
		if (!layoutSortingState || layoutSortingState.length === 0) {
			return;
		}

		const querySort: QuerySort = layoutSortingState.map((sortItem) => {
			const field = findPrimitiveFieldById(sortItem.fieldId);

			if (!field || !directions(field.id).includes(sortItem.direction)) {
				return null;
			}

			return {
				[field.apiName]: { direction: sortItem.direction },
			};
		}).filter(Boolean) as QuerySort;

		return querySort.length > 0 ? querySort : undefined;
	}

	return {
		convert,
	};
}
